import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

interface BackToModelsButtonProps {
  listPath: string;
}

const BackToModelsButton = ({
  listPath,
}: BackToModelsButtonProps): React.JSX.Element => (
  <RouterLink to={listPath} data-testid="back-to-models-link">
    <Button
      type="button"
      variant="reserve-text"
      size="md"
      className="pl-0 pr-1 mb-1.5"
      iconBefore={<Icons.ChevronLeft customClass="size-3.5 shrink-0" />}
    >
      Back to models
    </Button>
  </RouterLink>
);

export default BackToModelsButton;
